export default {
    init() {
        console.log("Blogging :3");
        $(".article").filter(function(index, element){
            console.log("Index: ", (index + 1) % 3 == 0);
            return (index + 1) % 4 == 0;
        }).addClass("article-fourth");
    }
}